import React from "react";
import { SharedMarketPlaceTradeAdvises } from "@app/shared";

const MarketPlaceTradeAdviseList: React.FC = () => {
  return <SharedMarketPlaceTradeAdvises />;
};

export default MarketPlaceTradeAdviseList;
